import { createAction } from '@reduxjs/toolkit';
import type { FileExport } from '~/store/frontendState/processing/processing.state';
import {
  FRONTEND_STATE_PROCESSING_BOUNDARIES_INITIALIZED,
  FRONTEND_STATE_PROCESSING_EXPORT_IMAGE_MODE_INITIALIZED,
  FRONTEND_STATE_PROCESSING_GOOGLE_SCRIPT_INITIALIZED,
  FRONTEND_STATE_PROCESSING_IMAGE_EXPORT_IN_PROGRESS,
  FRONTEND_STATE_PROCESSING_MARKERS_RENDERING_START,
  FRONTEND_STATE_PROCESSING_MARKERS_RENDERING_STOP,
  FRONTEND_STATE_PROCESSING_SET_FIRST_ZOOM,
} from './processing.actionTypes';

export const frontedStateProcessingGoogleScriptInitialized = () => ({
  type: FRONTEND_STATE_PROCESSING_GOOGLE_SCRIPT_INITIALIZED,
}) as const;

export const frontendStateProcessingExportImageExportInProgress = (inProgress: boolean) => ({
  type: FRONTEND_STATE_PROCESSING_IMAGE_EXPORT_IN_PROGRESS,
  payload: {
    inProgress,
  },
}) as const;

export const frontedStateProcessingRenderingMarkersStart = () => ({
  type: FRONTEND_STATE_PROCESSING_MARKERS_RENDERING_START,
}) as const;

export const frontedStateProcessingRenderingMarkersStop = () => ({
  type: FRONTEND_STATE_PROCESSING_MARKERS_RENDERING_STOP,
}) as const;

export const frontedStateProcessingBoundariesInitialized = () => ({
  type: FRONTEND_STATE_PROCESSING_BOUNDARIES_INITIALIZED,
}) as const;

export const frontendStateProcessingSetFirstZoom = (newValue: number) => ({
  type: FRONTEND_STATE_PROCESSING_SET_FIRST_ZOOM,
  payload: {
    newValue,
  },
}) as const;

export const frontendStateProcessingExportImageModeInitialized = () => ({
  type: FRONTEND_STATE_PROCESSING_EXPORT_IMAGE_MODE_INITIALIZED,
}) as const;

export const processingExportCreate = createAction(
  'FRONTEND_STATE_PROCESSING_EXPORT_CREATE',
  (fileExport: Omit<FileExport, 'resultPages'>) => ({
    payload: {
      fileExport,
    },
  })
);

export const processingExportRemove = createAction(
  'FRONTEND_STATE_PROCESSING_EXPORT_REMOVE',
  (id: Uuid) => ({ payload: { id } })
);

export const processingExportSetError = createAction(
  'FRONTEND_STATE_PROCESSING_EXPORT_SET_ERROR',
  (id: Uuid, error: string, pageIndex?: number) => // if no page index it means first page
    ({ payload: { id, error, pageIndex } })
);

export const processingExportSetPageSuccessResults = createAction(
  'FRONTEND_STATE_PROCESSING_EXPORT_SET_PAGE_RESULTS',
  (id: Uuid, pageIndex: number, results: { fileUrl?: string; data?: string }) => ({
    payload: { id, pageIndex, results },
  })
);

export const processingExportSetNextPagePending = createAction(
  'FRONTEND_STATE_PROCESSING_EXPORT_SET_NEXT_PAGE_PENDING',
  (id: Uuid) => ({ payload: { id } })
);
